
<template>

  <main class="room-outer" v-if="room.info">

    <div class="room-marquee room-perim room-top">
      <div class="room-quad info-quad">
        <div class="ob-header room-header" style="border-top-left-radius:4px;">
          <div class="room-title">
            <h3>{{room.info.hvacName}}</h3>
            <small>{{truncate($store.getters.getActiveBuilding().info.name, 30)}} <span style="color:rgb(0,153,191);">|</span> {{truncate($store.getters.getActiveFloor().info.name, 20)}}</small>
            <small style="color:lightblue;width:100%;text-align:left;margin-top:3px;"><u>{{room.info.apid}}</u></small>
          </div>
          <div class="ob-img" style="border-top-right-radius:4px;">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/company.png" />
          </div>
        </div>
        <div class="room-info-body">
          <div class="room-info-utility">
            <h6 class="battery" :style="{'color': setBat().color}"><img :src="setBat().img" />{{(room.meas && room.meas.bat) ? room.meas.bat : '-'}}%</h6>
            <!-- <div class="signal-strength">
              <h6 class="sig-bars" style="color:#71C076;"><span style="margin-right:5px">74%</span><div class="sig-bar" v-for="sig in signalStr()" :style="{'background-color': sig.color, 'border': `1px solid ${sig.color}`, 'height': sig.height}"></div></h6>
            </div> -->
          </div>
          <footer class="room-info-footer">
            <small style="text-align:left;">{{clauses.lastUp}}: {{normalizeUpdated()}}</small>
            <div class="room-util" @click="refresh">
              <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/reload.png" />
            </div>
          </footer>
        </div>
      </div>
      <div class="room-quad days-quad">
        <room-rdg-component :rdgOne="'days'" :rdgTwo="'dpr'" :dpr="room.info.coilSensor || false" :calibFlag="room.meas.calibFlag"></room-rdg-component>
      </div>
      <div class="room-quad env-quad">
        <room-rdg-component :rdgOne="'ttp'" :rdgTwo="'hhm'" :calibFlag="room.meas.calibFlag"></room-rdg-component>
      </div>
      <div class="room-quad iaq-quad">
        <room-rdg-component :rdgOne="'iaq'" :rdgTwo="'co2'" :calibFlag="room.meas.calibFlag"></room-rdg-component>
      </div>
    </div>

    <div class="room-marquee room-mid" v-if="trend==='all'">
      <div class="chart-head">
        <h4>{{clauses.dTrends}}</h4>
      </div>
      <chart-component v-on:addOverlay="graphOverlay = true" v-on:navDay="dayTrend($event)" :did="room.did" v-on:setBackButton="setBackLabel($event)"></chart-component>
      <div class="chart-overlay" v-if="graphOverlay">
        <h3>{{clauses.learnBlurb}}</h3>
      </div>
    </div>

    <div class="room-marquee room-mid" v-if="trend==='load'" style="justify-content:center;">
      <!-- <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/trend.png" /> -->
      <trend-loader></trend-loader>
    </div>

    <div class="room-marquee room-mid" v-if="trend==='day'">
      <div class="chart-head" style="width:250px;height:40px;justify-content:space-between;">
        <div class="day-back" @click="resetTrends">
          <h4><</h4>
          <h5>{{$store.state.backLabel}}</h5>
        </div>
        <h4 style="margin-right:15%;">{{dayLabel}}</h4>
      </div>
      <chart-component :trend="hourlyTrend" v-on:backToAll="trend = 'all'" style="width:100%;height:100%;"></chart-component>
    </div>

    <div class="room-marquee room-perim room-bot">
      <div class="room-tri equip-tri">
        <div class="tri-head equip-head">
          <h5
            :style="{
              'writing-mode': $store.state.lang === 'en' ? '' : 'tb-rl',
              'transform': $store.state.lang === 'en' ? '' : 'rotate(0deg)'
            }">
              {{clauses.equip}}
          </h5>
        </div>
        <div class="tri-lg" style="justify-content:center;">
          <h1>{{parent && parent.info ? parent.info.altConfig.toLowerCase() : room.info.altConfig.toLowerCase()}}</h1>
          <div class="on-off" style="margin:0px;">
            <h6 v-if="!room.parent || room.parent === true">{{onOffImg().text}}</h6>
            <h6 v-else :style="{'border-bottom': `1px solid ${parent && parent.meas && parent.meas.run ? '#71C076' : 'gray'}`}">{{onOffImg().text}}</h6>
            <img style="margin:5px 0px 0px 0px;" :src="onOffImg().img" />
          </div>
          <!-- <h5>{{clauses.runtime}}</h5>
          <h6>{{clauses.coming}}</h6> -->
        </div>
        <div class="rdg-sep"></div>
        <div class="tri-info" style="overflow-x:hidden;overflow-y:scroll;">
          <div class="det" v-for="det in equipDet">
            <div class="det-head">
              <h6>{{det.label}}</h6>
            </div>
            <div class="det-body">
              <h6>{{assessDet(det.val)}}</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="room-tri alerts-tri">
        <div class="tri-head alerts-head">
          <h5
            :style="{
              'writing-mode': $store.state.lang === 'en' ? '' : 'tb-rl',
              'transform': $store.state.lang === 'en' ? '' : 'rotate(0deg)'
            }"
          >
            {{clauses.alerts}}
          </h5>
        </div>
        <div class="alerts-list">
          <div class="room-alert" v-for="alert in genAlerts()" :style="{'background-color': alert.color}">
            <img v-if="!alert.img.includes('@')" :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${alert.img}.png`" />
            <img v-else src="@/assets/coilFlow.png" />
            <h6><span v-if="alert.color === '#a82232'">{{clauses.crit}}<br /></span><span>{{alert.label}}</span><span v-if="alert.color !== '#a82232'"><br />{{clauses.warn}}</span></h6>
          </div>
        </div>
      </div>
      <div class="room-tri maint-tri">
        <div class="tri-head maint-head">
          <h5
            :style="{
              'writing-mode': $store.state.lang === 'en' ? '' : 'tb-rl',
              'transform': $store.state.lang === 'en' ? '' : 'rotate(0deg)'
            }"
          >
            {{clauses.maint}}
          </h5>
        </div>
        <div class="alerts-list">
          <img style="width:100px;" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/comingSoon.png" />
        </div>
      </div>
    </div>

    <div class="refresh-overlay" v-if="refreshing">
      <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/reload.png" />
    </div>

  </main>

</template>

<script>

import moment from 'moment';
import axios from 'axios';

import Rdg from './Rdg';
import Chart from './Chart';
import Load from './TrendLoad';

import Helper from '@/lib/langTemplates/HelperClauses';

export default {

  data(){
    return {
      equipDet: [],
      graphOverlay: false,
      refreshing: false,
      trend: 'all',
      dayLabel: -1,
      hourlyTrend: {},
      room: {},
      backLabel: 'Daily'
    }
  },

  components: {
    'room-rdg-component': Rdg,
    'chart-component': Chart,
    'trend-loader': Load
  },

  computed: {
    rm(){
      return this.$store.getters.getActiveRoom();
    },
    clauses(){
      const Room = require('@/lib/langTemplates/RoomTemplate');
      const Card = require('@/lib/langTemplates/CardTemplate');
      const lang = {...Room.clauses, ...Card.clauses};
      let lPref = this.$store.state.lang;
      return Object.keys(lang).reduce((a, i) => {
        a[i] = lang[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    setBackLabel(event){
      this.backLabel = event;
    },

    setEquipDetails(){
      this.equipDet = [
        {
          val: 'manufacturer',
          label: this.clauses.manuf
        },
        {
          val: 'modelNumber',
          label: this.clauses.model
        },
        {
          val: 'fType',
          label: this.clauses.fType
        },
        {
          val: 'fBrand',
          label: this.clauses.fBrand
        },
        {
          val: 'fModel',
          label: this.clauses.fModel
        },
        {
          val: 'altSize',
          label: this.clauses.fSize
        }
      ]
    },

    truncate(str, limit){
      return str.length <= limit ? str : str.substring(0, limit - 3) + '...';
    },

    setBat(){
      let batInfo;
      if (!this.room.meas || !this.room.meas.bat || !parseInt(this.room.meas.bat)) {
        batInfo = {color: '#545457', img: 'bat'};
      } else {
        const bat = this.room.meas.bat;
        if (bat > 50) {
          batInfo = {color: '#71C076', img: 'goodBattery'};
        } else if (bat > 25) {
          batInfo = {color: '#E6A752', img: 'averageBattery'};
        } else {
          batInfo = {color: '#71C076', img: 'goodBattery'};
        }
      }
      batInfo.img = `https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${batInfo.img}.png`;
      return batInfo;
    },

    signalStr(){
      return ['5px', '10px', '15px'].map(i => ({height: i, color: '#71C076'}));
    },

    genAlerts(){
      const self = this;
      if (!this.room.alerts) {
        return []
      }
      let alertArr = Object.keys(this.room.alerts).map(i => {
        if (this.room.alerts[i].crit) {
          return {rdg: i, tier: 'crit'};
        } else if (this.room.alerts[i].bad) {
          return {rdg: i, tier: 'bad'};
        } else {
          return null;
        }
      }).filter(Boolean);
      if (this.room.info.coilSensor) {
        const daysAlert = alertArr.find(alert => alert.rdg == 'days');
        if (daysAlert) alertArr.splice(alertArr.indexOf(daysAlert), 1);
      }
      const alerts = alertArr.map(x => ({
        color: x.tier === 'crit' ? '#a82232' : '#c7ac4e',
        img: x.rdg == 'deltaPressure95Percentile' ? '@/assets/coilFlow.png' : setImg(x.rdg, self.clauses).img,
        label: x.rdg == 'deltaPressure95Percentile' ? 'Pressure' : setImg(x.rdg, self.clauses).label
      }));
      return alerts;
    },

    normalizeUpdated(){
      return this.room.meas && this.room.meas.tms
        ? moment(this.room.meas.tms * 1000).format('MMM DD @ hh:mm A')
        : '-';
    },

    async refresh(){
      this.refreshing = true;
      const room = await this.$store.dispatch('refreshRoom', this.room.did);
      this.room = room;
      setTimeout(() => this.refreshing = false, 4000);
    },

    async dayTrend(event){
      this.trend = 'load';
      this.$store.dispatch('setTrendDayTms', event.tms);
      this.hourlyTrend = await getDayTrends(event, this.room.did, this.$cookies.get('breeziProTkn'));
      if (this.hourlyTrend.err) {
        this.$store.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.trendFail[`${this.$store.state.lang}Title`],
          body: Helper.clauses.trendFail[this.$store.state.lang]
        });
      } else {
        this.dayLabel = moment(event.tms*1000).format('MMM DD, YYYY');
        setTimeout(() => {
          this.trend = 'day';
        }, 3000);
      }
    },

    async sequentialTrend(event){
      this.trend = 'load';
    },

    resetTrends(){
      this.trend = 'load';
      if (this.$store.state.backLabel == 'Hourly') {
        this.$store.dispatch('updateBackLabel', 'Daily');
        this.dayTrend({tms: this.$store.state.trendDayTms, granularity: 'overall'});
      } else {
        this.hourlyTrend = {};
        setTimeout(() => {
          this.trend = 'all';
          this.dayLabel = -1;
        }, 3000);
      }
    },

    onOffImg(){
      const room = this.parent ? this.parent : this.room;
      const hvacOn = room.meas && room.meas.run ? true : false;
      return {
        img: require(hvacOn ? '@/assets/on.png' : '@/assets/off.png'),
        text: hvacOn ? 'HVAC ON' : 'HVAC OFF'
      }
    },

    assessDet(val){
      const room = this.parent && this.parent.info ? this.parent : this.room;
      return this.truncate(room.info[val] && room.info[val].length > 1 ? room.info[val] : 'not specified', 15)
    }

  },

  mounted(){
    if (Math.round(Date.now()/1000) >= this.$store.state.sessionEnd) {
      this.$store.dispatch('logoutNotif');
      this.$router.push({path: '/'});
    }
    this.setEquipDetails();
    this.room = this.rm;
    if (this.room.parent && typeof this.room.parent == 'string') this.parent = this.$store.getters.getParentRoom(this.room.parent) || false;
  },

  watch: {
    '$screen.breakpoint': function(newData, oldData){
      if (newData !== 'lg') this.$router.push({path: `/card/${this.$store.state.roomIndex}`});
    }
  }

}

function setImg(r, clauses){
  switch (r) {
    case 'days':
      return {img: 'filterOfficial', label: clauses.filter};
    break;
    case 'ttp':
      return {img: 'temp', label: clauses.temp};
    break;
    case 'hhm':
      return {img: 'hum', label: clauses.hum};
    break;
    case 'iaq':
      return {img: 'tvocNoText', label: clauses.aq};
    break;
    case 'co2':
      return {img: 'eCO2', label: clauses.c2};
    break;
    case 'voc':
      return {img: 'tvocWithText', label: 'tVOC'};
    break;
    case 'dpr':
      return { img: '@/assets/coilFlow.png'}
    break;
  }
}

async function getDayTrends(event, did, tkn){
  const url = `https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/dailyTrends/${did}?start=${event.tms}${event.granularity == 'overall' ? '' : '&sequential=initial'}`;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: tkn
  }
  try {
    const dayTrend = (await axios.get(url, {headers: headers})).data;
    return dayTrend;
  } catch(err) {
    return {err: err};
  }
}

</script>

<style>

.room-outer {
  width: 85%;
  height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.room-marquee {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: .3%;
}

.room-perim {
  height: 20%;
}

.room-mid {
  height: 55%;
  background-color: #424245;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}

.room-quad {
  width: 24.5%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.info-quad {
  background-color: #424245;
  flex-direction: column;
  justify-content: flex-start;
}

.days-quad {
  background-color: #7f44c9;
}

.env-quad {
  background-color: #71C076;
  /* background-color: #e2983c; */
}

.iaq-quad {
  background-color: gray;
}

.room-title {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.room-title h3 {
  width: 100%;
  margin: 2px;
  text-align: left;
}

.room-info-body {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.room-info-utility {
  width: 90%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.signal-strength {
  width: 40px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sig-bar {
  width: 10px;
  margin: 2px;
}

.sig-bars {
  width: 50px;
  height: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}

.room-tri {
  width: 32.6%;
  height: 100%;
  background-color: #424245;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.equip-tri {
  border: 2px solid rgb(0, 153, 191);
}

.alerts-tri {
  border: 2px solid #cc7e3a;
  justify-content: flex-start;
}

.maint-tri {
  border: 2px solid #009058;
}

.tri-head {
  height: 100%;
  width: 6%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tri-head h5 {
  margin: 0px;
  transform: rotateZ(-90deg);
}

.equip-head {
  background-color: rgb(0, 153, 191);
}

.alerts-head {
  background-color: #cc7e3a;
}

.maint-head {
  background-color: #009058;
}

.room-bot {
  margin-top: .5%;
  width: calc(100% - 4px);
}

.tri-lg {
  width: 33%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tri-lg h5 {
  background-color: gray;
  color: #424245;
  margin: 2px;
}

.tri-lg h6 {
  color: gray;
  margin: 2px;
}

.tri-lg h1 {
  font-weight: lighter;
  border-bottom: 1px solid #dce1ec;
  margin: 3px;
}

.rdg-sep {
  width: 2px;
  height: 60%;
  background-color: lightgray;
}

.tri-info {
  width: 63%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: scroll;
}

.det {
  height: 22px;
  width: 95%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin: 1.5px;
}

.det h6 {
  margin: 0px;
}

.det-head {
  width: 40%;
  height: 100%;
  background-color: rgb(0, 153, 191);
  display: flex;
  justify-content: center;
  align-items: center;
}

.det-body {
  width: 40%;
  height: calc(100% - 4px);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgb(0, 153, 191);
}

.alerts-list {
  width: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.room-alert {
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
  border-radius: 5px;
  position: relative;
}

.room-alert img {
  height: 50%;
}

.room-alert h6 {
  position: absolute;
  bottom: -80%;
  text-align: center;
}

.chart-head {
  width: 150px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(0, 153, 191);
  border-radius: 3px;
}

.chart-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.chart-overlay h3 {
  width: 250px;
  color: red;
  border: 2px solid red;
  padding: 3px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  font-weight: lighter;
}

.room-info-footer {
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.room-util {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.room-util img {
  height: 100%;
}

.day-back {
  width: 60px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #dce1ec;
  cursor: pointer;
}

.day-back h4 {
  width: 100%;
  text-align: center;
  margin: 0px;
  color: rgb(0, 153, 191);
}

.day-back h5 {
  width: 100%;
  text-align: center;
  margin: 0px;
  color: rgb(0, 153, 191);
}

</style>



// WEBPACK FOOTER //
// src/components/room/Room.vue